// import brandLogo from 'assets/logo.png'

const authBrandLogo = () => {
  // @TODO: Change logo and remove this  wrapper
  // return brandLogo
  return
}

export default authBrandLogo
